import gql from 'graphql-tag';

export default gql`
query getLanguageIdByHandle($handle: String!) {
  languages(where: {handle: {_eq: $handle}}) {
    language_id
  }
}
`;
